// 场次核销
export default {
    heard_title: "Show List",
    // 表单
    fl_scheduleTime: "Write off date:",
    fp_scheduleTime: "write-off date",
    fl_store: "Verify store:",
    fp_store: "store for verification",
    op_all: "all",
    fl_orderNo: "Order number:",
    fp_orderNo: "Please enter order number",
    fl_proj: "Project:",
    fp_proj: "project",
    fl_scheduleCode: "Schedule:",
    fp_scheduleCode: "schedule",
    fl_consumed: "All written off:",
    fp_consumed: "Consumed status",
    op_true: "Yes",
    op_false: "No",
    // 表格
    tl_scheduleTime: "Write off date",
    tl_storeName: "Verify Store",
    tl_orderNo: "Order No.",
    tl_projectName: "Project Name",
    tl_scheduleCode: "Schedule",
    tl_consumeQuantity: "Consume Quantity",
    tl_memo: "Memo",
    btn_addMemo: "Add Memo",

    // 备注弹出框
    dt_memo: "Memo",
    dp_memo: "Please enter a remark",

    rm_memo: "Please enter a remark",
    sm_update: "Save successfully"
};
